import { BaseEntity } from 'yt-ng-framework';

export class KomitentObjekatView extends BaseEntity {
    constructor(){
        super();
    }
    KomitentNaziv: string = null;
    NazivObjekta: string = null;
    MestoNaziv: string = null;
    ObjekatPostBroj: string = null;
    ObjekatAdresa: string = null;
    Gln:string=null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.KomitentNaziv = input.KomitentNaziv;
        this.NazivObjekta = input.NazivObjekta;
        this.MestoNaziv = input.MestoNaziv;
        this.ObjekatPostBroj=input.ObjekatPostBroj;
        this.ObjekatAdresa=input.ObjekatAdresa;
        this.Gln=input.Gln;
        
        return this;
    }

    Serialize(input: KomitentObjekatView){
        return input;
    }
}